module.exports = __webpack_public_path__ + "img/gold3.a9650f1f.png";